import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_13: DocMigration = {
  maxSchemaVersion: "0.0.13",
  apply(json: any) {
    if (!json.electricalSystem.roomClearRules) {
      json.electricalSystem.roomClearRules = {};
    }

    return json;
  },
};

export default migration_0_0_13;
